import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-wmsm-AribaPage',
  templateUrl: './wmsm-AribaPage.component.html',
  styleUrls: ['./wmsm-AribaPage.component.scss']
})
export class WmsmAribaPageComponent extends BaseComponent implements OnInit {
  fileList: NzUploadFile[] = [];
  loading: boolean = false;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  constructor(
    private matomotracker:MatomoTracker,
  ) { super() }

  ngOnInit() {
    this.matomotracker.trackPageView("跳转AribaPage")
    this.matomotracker.trackEvent("跳转AribaPage","跳转AribaPage","Transation",1);
    window.open("https://s3.ariba.com/Sourcing/Main/aw?awh=r&awssk=qScRmSZM&realm=wistron&dard=1#b0")
  }
}
